import { styled } from '@mui/material';
import { Link as AppLink } from 'react-router-dom';

import Icon from '../Icon/Icon';

export const Header = styled('header')(({ theme }) => ({
  position: 'sticky',
  zIndex: 50,
  top: '40px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '56px',
  width: 'calc(100% - 80px)',
  maxWidth: '1732px',
  height: '90px',
  padding: '0 16px',
  backgroundColor: theme.palette.color.grey.dark16,
  borderRadius: '24px',

  [theme.breakpoints.down('2xl')]: {
    top: '20px',
    width: 'calc(100% - 60px)',
    maxWidth: '1328px',
    height: '76px',
  },
  [theme.breakpoints.down('lg')]: {
    height: '72px',
  },
  [theme.breakpoints.down('md')]: {
    width: 'calc(100% - 40px)',
    height: '64px',
  },
  [theme.breakpoints.down('sm')]: {
    top: '16px',
    width: 'calc(100% - 32px)',
    height: '56px',
  },
}));

export const LogoBlock = styled(AppLink)(() => ({
  display: 'flex',
  transition: 'opacity 0.3s ease-in-out',

  '&:hover': {
    opacity: '0.7',
  },
}));

export const Logo = styled(Icon)(({ theme }) => ({
  width: '110px',
  height: '32px',

  [theme.breakpoints.down('2xl')]: {
    width: '100px',
    height: '28px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '84px',
    height: '24px',
  },
}));

export const Links = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  height: '100%',
  gap: '40px',

  [theme.breakpoints.down('xl')]: {
    display: 'none',
  },
}));

export const Link = styled(AppLink, {
  shouldForwardProp: (prop) => prop !== 'isLinkActive',
})(({ theme, isLinkActive }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  pointerEvents: isLinkActive ? 'none' : 'auto',
  transition: 'opacity 0.3s ease-in-out',

  '&:hover': {
    opacity: '0.7',
  },
  '&::before': {
    position: 'absolute',
    content: '""',
    left: 0,
    bottom: 0,
    width: '100%',
    height: '4px',
    borderRadius: '4px 4px 0 0',
    opacity: isLinkActive ? 1 : 0,
    backgroundColor: theme.palette.color.fg.primary,
    transform: isLinkActive ? 'scaleX(1)' : 'scaleX(0)',
    transitionProperty: 'transform, opacity',
    transformOrigin: 'left',
    transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  },
}));

export const Buttons = styled('div')(() => ({
  display: 'flex',
  gap: '12px',
}));

export const Auth = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Burger = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ theme, isOpen }) => ({
  position: 'relative',
  display: 'none',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '50px',
  height: '50px',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  outline: 'none',
  border: 'none',

  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    left: '50%',
    marginLeft: '-12px',
    width: '24px',
    height: '2px',
    borderRadius: '2px',
    backgroundColor: theme.palette.color.fg.primary,
    willChange: 'transform',
    transition: 'all 0.2s ease-in-out',
  },
  '&::before': {
    transform: isOpen ? 'rotate(45deg)' : 'translateY(-6px)',
  },
  '&::after': {
    transform: isOpen ? 'rotate(-45deg)' : 'translateY(6px)',
  },

  [theme.breakpoints.down('xl')]: {
    display: 'flex',
  },
  [theme.breakpoints.down('lg')]: {
    width: '48px',
    height: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '44px',
    height: '44px',
  },
}));
